export default __webpack_public_path__ + "static/media/FormDCertificate.0b38d536.png";